import { AxiosResponse } from 'axios';
import { useAlert, useAuth } from 'core/contexts';
import { useQuery, UseQueryResult } from 'react-query';
import { commonShowAlert } from '../lib';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';

const getPipelinesList = async (
    url: string,
    token: string
): Promise<AxiosResponse<any, any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response;
};

export const usePipelinesList = (
    isEnabled: boolean
): UseQueryResult<AxiosResponse<any>, unknown> => {
    const { getToken } = useAuth();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    const url = '/metadata/datapipeline';

    return useQuery(
        'pipelines',
        async () => getPipelinesList(url, getToken()),
        {
            enabled: isEnabled,
            onError: (error: any) => {
                const errorMessage: string =
                    error?.data?.message ?? 'Unable to retrieve pipeline data';
                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
